export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export interface SkeletonBreakpointConfig {
  default?: number | string;
  xs?: number | string;
  sm?: number | string;
  md?: number | string;
  lg?: number | string;
  xl?: number | string;
}

export type ResponsiveProp = number | string | SkeletonBreakpointConfig;
